export enum State {
    Normal,
    BusyLoggingIn,
    LoginFailed,
}
